import { render, staticRenderFns } from "./EditIncidenceForm.vue?vue&type=template&id=afdda732&"
import script from "./EditIncidenceForm.vue?vue&type=script&lang=js&"
export * from "./EditIncidenceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports